<template>
    <div class="container">
        <div class="header">
            <div class="qrCode">
                <img
                    :src="
                        card.healthCardLink
                            ? card.healthCardLink.healthCode
                            : ''
                    "
                />
            </div>
            <div class="line"></div>
        </div>
        <div class="content">
            <div class="name">{{ card.name }}</div>
            <div class="tag" v-if="card.isDefault">
                <span>默认</span>
            </div>
            <div class="medicalCardTypeName">
                {{ card.medicalCardTypeName }}
            </div>
            <div class="idNo">{{ card.idNo }}</div>
            <div class="genderName">性别：{{ card.genderName }}</div>
            <div class="birthday">出生日期：{{ card.birthday }}</div>
            <div class="phone">联系电话：{{ card.phone }}</div>
            <div class="address">地址：{{ card.address }}</div>
        </div>

        <div class="tools">
            <van-button
                round
                block
                size="small"
                type="primary"
                native-type="button"
                @click="show = true"
            >
                管理就诊卡
            </van-button>
        </div>

        <van-action-sheet
            v-model="show"
            @select="onSelect"
            :actions="actions"
            cancel-text="取消"
        />
    </div>
</template>

<script>
import medicalCardApi from '@/api/medicalCardApi';

export default {
    data() {
        return {
            card: {},
            show: false,
            actions: [{
                name: '设为默认',
                loading: false,
                action: 'default'
            }, {
                name: '修改资料',
                loading: false,
                action: 'edit'
            }, {
                name: '解绑就诊卡',
                loading: false,
                action: 'unbundling'
            }]
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            medicalCardApi.getMedicalCard(this.cardId).then(res => {
                this.card = res.data;
            });
        },
        onSelect(item) {
            const { init, $dialog, $router, cardId, card } = this;
            if (item.action === 'default') {
                item.loading = true;
                medicalCardApi.setDefault(this.card.id, this.card.organId).then(res => {
                    init();
                    this.show = false;
                    $dialog.alert({
                        message: '设置成功',
                    });
                }).finally(() => {
                    item.loading = false;
                });
            } else if (item.action === 'edit') {
                //电子健康卡
                if (2 === card.medicalCardType) {
                    $router.push({
                        path: '/medical_card/edit_health_card',
                        query: {
                            cardId
                        }
                    });
                }
            } else if (item.action === 'unbundling') {
                item.loading = true;
                medicalCardApi.unBundling(this.card.id, this.card.organId).then(res => {
                    this.show = false;
                    $dialog.alert({
                        message: '解绑成功',
                    }).then(() => {
                        $router.replace({
                            path: '/medical_card/card_list',
                            query: {
                                organId: this.card.organId
                            }
                        });
                    });
                }).finally(() => {
                    item.loading = false;
                });
            }
        },
    },
    props: {
        cardId: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    padding: 0.533333rem 0.4rem;
    margin-bottom: 1.333333rem;

    .header {
        background-color: @white-color;
        text-align: center;
        position: relative;
        border-top-right-radius: 0.266667rem;
        border-top-left-radius: 0.266667rem;
        background: radial-gradient(
                    circle at bottom right,
                    transparent 0.4rem,
                    @white-color 0
                )
                bottom right,
            radial-gradient(
                    circle at bottom left,
                    transparent 0.4rem,
                    @white-color 0
                )
                bottom left;
        background-size: 50% 100%;
        background-repeat: no-repeat;

        .qrCode {
            padding: 0.4rem 0.533333rem;
        }

        .line {
            position: relative;
            left: 0.4rem;
            right: 0.4rem;
            height: 0.026667rem;
            background-image: linear-gradient(
                to right,
                @grey-color 0%,
                @grey-color 50%,
                transparent 50%
            );
            background-size: 0.266667rem 0.266667rem;
            background-repeat: repeat-x;
            position: absolute;
            opacity: 0.5;
        }
    }

    .content {
        border-bottom-right-radius: 0.266667rem;
        border-bottom-left-radius: 0.266667rem;
        background: radial-gradient(
                    circle at top right,
                    transparent 0.4rem,
                    @white-color 0
                )
                top right,
            radial-gradient(
                    circle at top left,
                    transparent 0.4rem,
                    @white-color 0
                )
                top left;
        background-size: 50% 100%;
        background-repeat: no-repeat;
        padding: 0.4rem 0.8rem;

        .name {
            font-size: 0.48rem;
            font-weight: 600;
            line-height: 0.96rem;
            color: @black-color;
        }

        .medicalCardTypeName {
            margin-top: 0.4rem;
            font-size: 0.373333rem;
            color: @grey-color;
            line-height: 1.5;
            opacity: 0.8;
        }

        .idNo {
            font-size: 0.426667rem;
            font-weight: 500;
            line-height: 1.5;
            margin-bottom: 0.4rem;
            color: @black-color;
        }

        .genderName,
        .birthday,
        .phone,
        .address {
            opacity: 0.8;
            font-size: 0.373333rem;
            color: @grey-color;
            line-height: 1.45;
        }

        .tag {
            line-height: 0.266667rem;

            span {
                padding: 0.053333rem 0.213333rem;
                font-size: 0.266667rem;
                border-radius: 0.08rem;
                line-height: 0.64rem;
                color: @primary-color;
                background-color: @white-color;
                border: 0.026667rem solid @primary-color;
            }
        }
    }

    .tools {
        position: fixed;
        bottom: 0;
        background-color: @white-color;
        padding: 0.213333rem 0.48rem;
        left: 0;
        right: 0;
        height: 0.933333rem;
        box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
        display: flex;
        align-items: center;
    }
}
</style>